/**
 * This util function checks if a specified property is unique among all objects
 * @param arrayOfObjects the array containing the objects
 * @param property the property name
 * @returns true if the values are different, false if all the values are the same
 */
export const areValuesDifferent = <T1, T2 = undefined>(
	arrayOfObjects: T1[],
	property: keyof T1,
	nestedProperty?: keyof T2
): boolean => {
	const uniqueValues = new Set(
		arrayOfObjects.map((obj) => {
			if (nestedProperty) {
				// @ts-ignore
				return obj[property][nestedProperty];
			}
			return obj[property];
		})
	);
	if (uniqueValues.size <= 1) {
		return false;
	}
	return true;
};
